import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export type UpdateRequisitionRequest = {
  id: string
  type?: 'BUY' | 'SELL'
  amount?: number | string
  currency_id?: string
  exchange_rate?: number | string
  country_id?: string
  description?: string
  validity_days?: string
  transfer_method_ids?: string[]
  iranian_source_bank_account_id?: string | null
  iranian_bank_account_id?: string | null
  international_bank_account_id?: string | null
  international_bank_account_method?: string | null
  international_paypal_bank_account_id?: string | null
  international_paypal_bank_account_method?: string | null
  international_revolut_bank_account_id?: string | null
  international_revolut_bank_account_method?: string | null
}

export interface UpdateRequisitionResponse {
  data: {
    id: string
    code: string
    currencyAmount: number
    exchangeRate: number
    description: string
    expiresAt: string
    finalRialAmount: number
    initialRialAmount: number
    commissionRialAmount: number
    status: string
    type: 'BUY' | 'SELL'
    availableForOffer: boolean
    totalOffers: number
    isOld: boolean
    createdAt: string
    currency: {
      id: string
      titleFa: string
      titleEn: string
      isoCode: string
    }
    country: {
      id: string
      title: {
        fa: string
        en: string
      }
      callingCode: number
    }
    owner: {
      id: string
      fullName: string
    }
    transferMethods: Array<{
      id: string
      title: string
      label: string
    }>
    bankAccounts: {
      sellerBank: unknown | null
    }
    bankAccountCountries: {
      seller: unknown | null
    }
    latestViewerOffer: unknown | null
    discount: unknown | null
  }
  meta: {
    message: string
    errors: string[]
  }
}

export function updateRequisitionAction(
  data: UpdateRequisitionRequest
): Promise<ApiResponse<UpdateRequisitionResponse>> {
  const { id, ...updateData } = data
  return api.put<ApiResponse<UpdateRequisitionResponse>>(`/requisitions/${id}`, updateData)
}
